import { render } from "./Text2.vue?vue&type=template&id=4706a014&scoped=true"
import script from "./Text2.vue?vue&type=script&lang=js"
export * from "./Text2.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-4706a014"

export default script